export default {"src":"/_next/static/media/patio.21e23209.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};